import React from 'react'
import isDOMAvailable from 'utils/isDOMAvailable'

let MonkeyTour

if (isDOMAvailable) {
  /* eslint-disable global-require */
  MonkeyTour = require('reactour').default || (() => <div />)
  /* eslint-enable global-require */
} else {
  MonkeyTour = () => <div />
}

const Tour = MonkeyTour

export default Tour
